// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qq-2";
export var chatLink = "_qq-0";
export var chatText = "_qq-1";